<div class="relative">
  <div
    class="h-15 min-w-15 flex gap-1 justify-center rounded-mib px-1 text-gray-700 active:bg-mib-branding-50 transition-colors text-xs"
    [class.pr-0]="displayCount()"
    [class.bg-mib-branding-50]="active()">
    <div class="flex flex-col justify-center items-center">
      <ng-content></ng-content>
    </div>

    @if (displayCount()) {
      <mai-count-badges
        [class.relative]="piiDetected()"
        [class.top-5]="piiDetected()"
        [class.-right-0]="piiDetected()"
        [successCount]="successCount()"
        [warningCount]="warningCount()"></mai-count-badges>
    }
  </div>
  @if (piiDetected()) {
    <span mibBadge class="absolute top-0 -right-6 gap-0.5" theme="danger" size="sm">
      <svg mib-icon name="shield" class="size-2.5" aria-hidden="true"></svg>
      PHI
    </span>
  }
</div>
